/* global CustomError */
class CustomError extends Error {
  constructor (message, options = {}) {
    // Passa o message e options (suporte nativo ao cause, desde ES2022)
    super(message, options)

    this.level = options.level || 'error'
    this.title = options.title || 'Ooops!'

    this.name = 'CustomError'

    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export default CustomError



// WEBPACK FOOTER //
// ./src/errors/customError.js